import PlusIcon from "shared/components/icons/plus_icon"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import "./diy_add_tanda_button.scss"

interface Props {
  allowNewBadge: string
  anchorTitle: string
  onClick: () => void
}

export default function DIYAddTandaButton({ allowNewBadge, anchorTitle, onClick }: Props) {
  return (
    <a
      className="plus-icon-button"
      styleName="add"
      onClick={verifyIntendedPromiseRejection(onClick)}
      title={anchorTitle}
      data-allow-new-badge={allowNewBadge}
    >
      <PlusIcon />
    </a>
  )
}
